<script lang="ts" setup>
defineProps<{
	classes?: string;
}>();
</script>

<template>
	<Row
		v-once
		justify="center"
	>
		<img
			alt="Loading"
			:class="classes ?? 'h-20'"
			src="/images/loading.svg"
			class="loading"
		/>
	</Row>
</template>
